import { type RectReadOnly } from 'react-use-measure';

interface CalcDiffArgs {
  from: RectReadOnly;
  to: RectReadOnly;
}

const calcDiff = ({ from, to }: CalcDiffArgs): number => {
  const toMiddleY = (to.bottom - to.top) / 2 + to.top;
  const fromMiddleY = (from.bottom - from.top) / 2 + from.top;

  return toMiddleY - fromMiddleY;
};

export { calcDiff };
